module.exports = __webpack_public_path__ + "static/img/me.76c434a6.svg";